export const validarData = (data, opcoes = {}) => {
  const {
    obrigatoria = true,
    naoPodeSerFutura = false,
    naoPodeSerPassada = false,
    dataMinima = null,
    dataMaxima = null,
    nomeCampo = "Data",
    dataReferencia = null,
  } = opcoes;

  if (obrigatoria && !data) {
    return `${nomeCampo} é obrigatória`;
  }

  if (!data) {
    return null;
  }

  const dataDate = new Date(data);
  if (isNaN(dataDate.getTime())) {
    return `${nomeCampo} inválida`;
  }

  const referencia = dataReferencia ? new Date(dataReferencia) : new Date();
  referencia.setHours(23, 59, 59, 999);

  if (dataMinima) {
    const dataMinimaDate = new Date(dataMinima);
    if (dataDate < dataMinimaDate) {
      const dataMinimaFormatada = dataMinimaDate.toLocaleDateString("pt-BR");
      return `${nomeCampo} não pode ser anterior a ${dataMinimaFormatada}`;
    }
  }

  if (dataMaxima) {
    const dataMaximaDate = new Date(dataMaxima);
    dataMaximaDate.setHours(23, 59, 59, 999);
    if (dataDate > dataMaximaDate) {
      const dataMaximaFormatada = dataMaximaDate.toLocaleDateString("pt-BR");
      return `${nomeCampo} não pode ser posterior a ${dataMaximaFormatada}`;
    }
  }

  if (naoPodeSerFutura && dataDate > referencia) {
    return `${nomeCampo} não pode ser futura`;
  }

  if (naoPodeSerPassada && dataDate < referencia) {
    return `${nomeCampo} não pode ser passada`;
  }

  return null;
};


export const validarDataAquisicao = (dataAquisicao) => {
  return validarData(dataAquisicao, {
    obrigatoria: true,
    naoPodeSerFutura: true,
    dataMinima: "1900-01-01",
    nomeCampo: "Data de Aquisição",
  });
};


export const validarDataSolicitacao = (dataSolicitacao) => {
  return validarData(dataSolicitacao, {
    obrigatoria: true,
    naoPodeSerFutura: true,
    dataMinima: "1900-01-01",
    nomeCampo: "Data de Solicitação",
  });
};


export const validarIntervaloDatas = (dataInicio, dataFim) => {
  if (!dataInicio || !dataFim) {
    return null;
  }

  const dataInicioDate = new Date(dataInicio);
  const dataFimDate = new Date(dataFim);

  if (isNaN(dataInicioDate.getTime()) || isNaN(dataFimDate.getTime())) {
    return "Datas inválidas";
  }

  if (dataInicioDate > dataFimDate) {
    return "A data inicial não pode ser posterior à data final";
  }

  return null;
};
